import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-light footerbox">
      <div className="container">
        <div className="row">

          {/* Brand & About */}
          <div className="col-lg-4">
            <div className="footer-links">
              <Link to="/" className="navbar-brand wht"><img src="/assets/img/footer-logo.png" className="logo-icon" alt=""/>Freelity</Link>
              <p>
              Free Online Tools for Everyday Tasks – 100% Free, No Login, No Limits | Fast, Easy & Secure Utility Tools for Work, Study, and Development.
              </p>
            </div>
          </div>

          <div className="col-lg-8 p-0">
            <div className="row m-0">
              {/* Tools Links */}
              <div className="col-lg-4">
                <div className="footer-links">
                  <h2>Popular Tools</h2>
                  <ul className="list-unstyled">
                    <li><Link to="/word-counter">Word Counter</Link></li>
                    <li><Link to="/json-formatter">JSON Formatter</Link></li>
                    <li><Link to="/qr-code-generator">QR Code Generator</Link></li>
                    <li><Link to="/online-stopwatch-timer">Online Stopwatch</Link></li>
                    <li><Link to="/youtube-thumbnail-downloader">YouTube Thumbnail Downloader</Link></li>
                  </ul>
                </div>
              </div>

              {/* Quick Links */}
              <div className="col-lg-4">
                <div className="footer-links">
                  <h2>Quick Links</h2>
                  <ul className="list-unstyled">
                    <li><Link to="/contact">Contact Us</Link></li>
                    <li><Link to="/about">About Us</Link></li>
                    <li><Link to="/disclaimer">Disclaimer</Link></li>
                    <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                    <li><Link to="/terms-and-conditions">Terms And Conditions</Link></li>
                  </ul>
                </div>
              </div>

              {/* Contact / Social */}
              <div className="col-lg-4">
                <div className="footer-links">
                  <h2>Connect With Us</h2>
                  <ul className="list-unstyled flexinline">
                    <li>
                      <i className="bi bi-geo-alt-fill"></i>
                      Bhucho Mandi, Bathinda, Punjab
                    </li>
                    <li>
                      <i className="bi bi-envelope-fill"></i>
                      <a href="mailto:support@freelity.com">support@freelity.com</a>
                    </li>
                    <li>
                      <i className="bi bi-telephone-fill"></i>
                      <a href="tel:9569333952">+91 95693-33952</a>
                    </li>
                  </ul>
                </div>
              </div>
              </div>
          </div>


          <hr className="bg-light my-3" />
          <div className="text-center pb-2" style={{ fontSize: '13px' }}>
            © {new Date().getFullYear()} Freelity. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
